import { Component, OnInit, Input, OnChanges, ChangeDetectorRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { ProfileDataService } from "app/main/shared/services/profile-data.service";
import { FullScreenLoaderService } from "app/main/shared/modules/full-screen-loader/full-screen-loader.service";
import { NotificationService } from "app/main/shared/services/notification.service";
import { BookOrderService } from "app/main/actions/book-order/book-order.service";
import { TenantService } from "app/main/shared/services/tenant.service";
import { ImageLinksDialogComponent } from "../image-links-dialog/image-links-dialog.component";
@Component({
  selector: "confirm-reverse",
  templateUrl: "./confirm-reverse.component.html",
  styleUrls: ["./confirm-reverse.component.scss"]
})
export class ConfirmReverseComponent {
  @Input() order: any;
  @Input() courierPartnerForm: FormGroup;
  @Input() reverseQCForm: FormGroup;
  @Input() reverseQCEnabled: boolean = false;
  @Input() itemsForm: any; // FormArray of items

  // weightCategory decalerations
  weightCategory = {
    d: "Actual Weight",
    v: "Volumetric Weight"
  };

  tenantConfig = this._tenantService.getTenantConfig();

  constructor(
    private _fullScreenLoader: FullScreenLoaderService,
    private _profileDataService: ProfileDataService,
    private _router: Router,
    private _bookOrderService: BookOrderService,
    private _notification: NotificationService,
    private _tenantService: TenantService,
    private _dialog: MatDialog,
    private _cdr: ChangeDetectorRef
  ) {
    // Bind method to ensure proper context
    this.openImageModal = this.openImageModal.bind(this);
  }

  getItemsForDisplay(): any[] {
    if (!this.reverseQCEnabled || !this.itemsForm) {
      return this.order.items || [];
    }
    
    const formItems = this.itemsForm.getRawValue();
    const displayItems = formItems.map((formItem: any, index: number) => {
      const originalItem = this.order.items[index] || {};
      const processedImages = Array.isArray(formItem.product_images) ? formItem.product_images : [];
      
      return {
        ...originalItem,
        ...formItem,
        product_name: formItem.name,
        product_images: processedImages
      };
    });
    
    return displayItems;
  }

  formatRvpType(rvpType: string): string {
    if (!rvpType) return '';
    return rvpType
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  openImageModal(images: string[]): void {
    this._dialog.open(ImageLinksDialogComponent, {
      data: { images: images || [] },
      width: '700px',
      maxWidth: '90vw',
      panelClass: 'image-links-dialog'
    });
  }

  onSubmit(): void {
    this._fullScreenLoader.show();

    const courierPartnerDetails = this.courierPartnerForm.get("courier").value;

    let body: any = {
      orderId: this.order.SG_ORDERID,
      courier: courierPartnerDetails.courierId,
      shippingAmount: courierPartnerDetails.price.price
    };

    // Add reverseQC payload if enabled
    if (this.reverseQCEnabled && this.reverseQCForm && this.itemsForm) {
      const reverseQCData = this.reverseQCForm.value;
      const itemsData = this.itemsForm.getRawValue();
      
      const items = itemsData.map((item: any) => ({
        product_name: item.name, // Use item name as product_name (synced)
        brand: item.brand || "",
        size: item.size || "",
        color: item.color || "",
        imei: item.imei || null,
        serial_no: item.serial_no || null,
        ean_barcode: item.ean_barcode || "",
        product_images: item.product_images || [],
        questions: item.questions || [],
        quantity: item.quantity || 1
      }));

      body.reverseQC = {
        qc_enable: reverseQCData.qc_enable,
        return_reason: reverseQCData.return_reason || "Wrong size delivered",
        rvp_type: reverseQCData.rvp_type || "open_box",
        items: items,
        qc_template_id: reverseQCData.qc_template_id,
        capture_min_images: reverseQCData.capture_min_images || 2,
        capture_max_images: reverseQCData.capture_max_images || 4,
        help_content: {
          description:
            reverseQCData.help_content?.description ||
            "Please verify product condition",
          url: reverseQCData.help_content?.url || null,
          is_mandatory: reverseQCData.help_content?.is_mandatory ?? true
        }
      };
    }

    this._bookOrderService.bookOrderApi(body).subscribe((res: any) => {
      this._fullScreenLoader.hide();
      if (res.success) {
        this._profileDataService.getProfileData();
        this._notification.show(res.msg);
        this._router.navigate(["orders"]);
      } else {
        this._notification.show(res.msg);
      }
    });
  }
}
